/* SupplyMate artifact port: shared behaviour (announcement rotation, menu / cart / search drawers, toast,
   homepage before-after slider and testimonials, collection pills and sort). Ported from the
   "SupplyMate Site Preview" artifact; the drawers use the same markup and classes. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  let SHOP = {};
  try { SHOP = JSON.parse($("#sm-shop-json")?.textContent || "{}"); } catch (e) {}
  const root = (SHOP.rootUrl || "/").replace(/\/$/, "");

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) { document.querySelector(".toast")?.remove(); const t = document.createElement("div"); t.className = "toast"; t.textContent = msg; document.body.appendChild(t); clearTimeout(toastTimer); toastTimer = setTimeout(() => t.remove(), 2600); }

  /* ---------- drawers ---------- */
  const layerEl = () => document.getElementById("layer");
  function closeLayer() { const l = layerEl(); if (l) l.innerHTML = ""; document.body.style.overflow = ""; }
  function layer(side, title, body, foot = "") {
    layerEl().innerHTML = `<div class="scrim" data-close></div><aside class="drawer ${side}" role="dialog" aria-label="${esc(title)}"><div class="drawer-head"><h3>${esc(title)}</h3><button class="icon-btn" data-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="drawer-body">${body}</div>${foot ? `<div class="drawer-foot">${foot}</div>` : ""}</aside>`;
    document.body.style.overflow = "hidden";
  }
  function setCount(n) { const c = $("#cart-count"); if (!c) return; c.textContent = n; c.hidden = !n; }

  async function openCart() {
    layer("right", "Your cart", `<p class="empty">Loading…</p>`);
    try {
      const r = await fetch(`${root}/?sections=sm-cart-drawer`, { credentials: "same-origin" });
      const j = await r.json();
      const box = document.createElement("div"); box.innerHTML = j["sm-cart-drawer"] || "";
      const d = box.querySelector("[data-count]");
      const body = d?.querySelector('[data-part="body"]')?.innerHTML || `<p class="empty">Your cart is empty.</p>`;
      let foot = d?.querySelector('[data-part="foot"]')?.innerHTML || "";
      let note = SHOP.cartNote || "";
      if (SHOP.freeShip) note = `${note} ${SHOP.freeShip}`.trim();
      foot = foot.replace("[[cart_note]]", esc(note));
      setCount(+(d?.dataset.count || 0));
      layer("right", d?.dataset.title || "Your cart", body, foot);
    } catch (e) { location.href = `${root}/cart`; }
  }
  window.smOpenCart = openCart;
  window.smToast = toast;
  window.smSetCount = setCount;

  function openSearch() {
    layer("right", "Search", `<form action="${root}/search" method="get" role="search"><input class="search-box" id="search-q" name="q" type="search" placeholder="${esc(SHOP.searchPlaceholder || "Search products")}" aria-label="Search products"><input type="hidden" name="type" value="product"></form><div class="search-results" id="search-r" style="margin-top:12px"></div>`);
    const q = $("#search-q");
    let timer;
    const go = async () => {
      const v = q.value.trim();
      if (!v) { $("#search-r").innerHTML = ""; return; }
      try {
        const r = await fetch(`${root}/search/suggest.json?q=${encodeURIComponent(v)}&resources[type]=product&resources[limit]=10`);
        const j = await r.json();
        const hits = j?.resources?.results?.products || [];
        $("#search-r").innerHTML = hits.map((p) => `<a href="${esc(p.url)}"><span class="thumb">${p.image ? `<img src="${esc(p.image)}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:6px">` : ""}</span><span>${esc(p.title)}</span><span class="num" style="color:var(--ink-2);font-size:13px">${+p.price > 0 ? "₹" + Math.round(+p.price).toLocaleString("en-IN") : "Quote"}</span></a>`).join("") || `<p class="empty">No products match “${esc(v)}”.</p>`;
      } catch (e) {}
    };
    q.addEventListener("input", () => { clearTimeout(timer); timer = setTimeout(go, 200); });
    q.focus();
  }
  function openMenu() { const t = $("#sm-menu-tpl"); layer("left", "Menu", t ? t.innerHTML : ""); }

  document.addEventListener("click", async (e) => {
    const l = layerEl();
    if (l && l.contains(e.target)) {
      const rm = e.target.closest("[data-remove]");
      if (rm) {
        e.preventDefault();
        await fetch(`${root}/cart/change.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 }) });
        openCart();
        return;
      }
      if (e.target.closest("[data-close]") || e.target.closest("a[href]")) closeLayer();
    }
    if (e.target.closest("#open-cart") || e.target.closest("#pm-tab-cart")) { e.preventDefault(); openCart(); }
    if (e.target.closest("#open-search")) openSearch();
    if (e.target.closest("#open-menu")) openMenu();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeLayer(); });

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- announcement rotation ---------- */
  const ann = $("#announce");
  if (ann) {
    let msgs = [];
    try { msgs = JSON.parse(ann.dataset.smAnnounce || "[]").filter(Boolean); } catch (e) {}
    let mi = 0;
    if (msgs.length > 1 && !reduce) setInterval(() => { mi = (mi + 1) % msgs.length; ann.innerHTML = msgs[mi]; }, 4000);
  }

  /* ---------- homepage: before / after slider ---------- */
  const cmp = $("#lh-cmp");
  if (cmp) {
    const range = $("#lh-cmp-range");
    const set = (pct) => { cmp.style.setProperty("--pos", `${Math.max(0, Math.min(100, pct))}%`); range.value = pct; };
    range.addEventListener("input", (e) => set(+e.target.value));
    let drag = false;
    const move = (x) => { const r = cmp.getBoundingClientRect(); set(((x - r.left) / r.width) * 100); };
    cmp.addEventListener("pointerdown", (e) => { drag = true; cmp.setPointerCapture(e.pointerId); move(e.clientX); });
    cmp.addEventListener("pointermove", (e) => drag && move(e.clientX));
    cmp.addEventListener("pointerup", () => (drag = false));
  }

  /* ---------- homepage: testimonials ---------- */
  const slides = [...document.querySelectorAll(".lh-q")], dots = [...document.querySelectorAll(".lh-dot")];
  if (slides.length) {
    let qi = 0;
    const show = (i) => { qi = (i + slides.length) % slides.length; slides.forEach((s, n) => (s.hidden = n !== qi)); dots.forEach((d, n) => d.setAttribute("aria-current", n === qi)); };
    dots.forEach((d, n) => d.addEventListener("click", () => show(n)));
    if (slides.length > 1 && !reduce) setInterval(() => show(qi + 1), 6000);
  }

  /* ---------- collection: pills (filter by product type) and sort ---------- */
  const pills = $("#pills[data-filter]");
  const results = $("#results");
  if (pills && results) {
    const cards = [...results.querySelectorAll(".card")];
    const count = $("#count");
    pills.addEventListener("click", (e) => {
      const b = e.target.closest("[data-f]");
      if (!b) return;
      pills.querySelectorAll(".pill").forEach((x) => x.setAttribute("aria-pressed", x === b));
      let n = 0;
      cards.forEach((c) => { const ok = b.dataset.f === "All" || c.dataset.type === b.dataset.f; c.hidden = !ok; if (ok) n++; });
      if (count) count.textContent = `${n} products`;
    });
  }
  const sort = $("#sort[data-sort-url]");
  if (sort) sort.addEventListener("change", () => { const u = new URL(location.href); u.searchParams.set("sort_by", sort.value); location.href = u.toString(); });
})();
